import { create } from 'zustand';
import type {
  IssuedTicketBobcatDataDTO,
  IssuedTicketBobcatDataMapDTO,
} from '@/api/trafikportalen';

interface TicketBobcatDataStore {
  byId: IssuedTicketBobcatDataMapDTO;
  setMany: (entries: IssuedTicketBobcatDataMapDTO) => void;
}

export const useTicketBobcatDataStore = create<TicketBobcatDataStore>(
  (set) => ({
    byId: {},
    setMany: (entries) =>
      set((state) => ({ byId: { ...state.byId, ...entries } })),
  }),
);

export const useTicketBobcatData = (
  ticketId: string,
): IssuedTicketBobcatDataDTO | undefined =>
  useTicketBobcatDataStore((state) => state.byId[ticketId]);
